import React from 'react';

/** Status and date-range fields inside the events filter popover. */
export default function EventFilterFields({ filters, setFilter, statusOptions }) {
  const onChange = (name) => (event) => setFilter(name, event.target.value);
  return (
    <>
      <label>
        <span>Status</span>
        <select value={filters.status_filter} onChange={onChange('status_filter')}>
          {statusOptions.map((option) => (
            <option key={option} value={option}>
              {option === 'all' ? 'Any status' : option.replaceAll('_', ' ')}
            </option>
          ))}
        </select>
      </label>

      <label className="events-date-field">
        <span>Date from</span>
        <input type="date" value={filters.date_from} onChange={onChange('date_from')} />
      </label>

      <label className="events-date-field">
        <span>Date to</span>
        <input type="date" value={filters.date_to} onChange={onChange('date_to')} />
      </label>
    </>
  );
}
